'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

export default function ZendeskWidget() {
  const pathname = usePathname();

  if (pathname.startsWith('/studio')) return null;

  return (
    <Script
      id="ze-snippet"
      src="https://static.zdassets.com/ekr/snippet.js?key=fb21b940-006b-41d9-9b31-0f0c1c0a4556"
      strategy="lazyOnload"
    />
  );
}
